import store from '../store/index'
import NP from 'number-precision'

/*
    number-precision 用法
    NP.strip(num)         // strip a number to nearest right number
    NP.plus(num1, num2, num3, ...)   // addition, num + num2 + num3, two numbers is required at least.
    NP.minus(num1, num2, num3, ...)  // subtraction, num1 - num2 - num3
    NP.times(num1, num2, num3, ...)  // multiplication, num1 * num2 * num3
    NP.divide(num1, num2, num3, ...) // division, num1 / num2 / num3
    NP.round(num, ratio)
*/

/*
    获取当前格式化时间
*/ 
export function getCurrentFormatTime() {
    let date = new Date()
    let Y = date.getFullYear()
    let M = addZero(date.getMonth() + 1)
    let D = addZero(date.getDate())
    let h = addZero(date.getHours())
    let m = addZero(date.getMinutes())
    let s = addZero(date.getSeconds())
    return Y + '年' + M + '月' + D + '日 ' + h + ':' + m + ':' + s
}
/*
    个位数前补零
*/ 
function addZero (n) {
    return +n < 10 ? '0' + n : n
}

/*
    计算供应商结算价
*/
export function settlePrice(value, rate) {
    let global_service_rate = NP.minus(1, store.state.app.globalServiceCharge)
    if (!value) return '--'
    if (!/^(\d*)(\.\d{1,})?$/.test(value)) return '--'
    if (rate == '') return '--'
    if (!/^\d*(\.\d{1,})?$/.test(rate)) return '--'
    if (parseFloat(rate) < 0 || parseFloat(rate) > 100) return '--'
    rate = accDiv(rate, 100) // parseFloat(rate) / 100
    let resWithoutPlatform = accMul(value, global_service_rate);
    let resResult = accMul(resWithoutPlatform, rate).toFixed(2)
    return resResult
}

/*
    计算供应商供货价
*/
export function supplierPrice(value, rate) {
    if (!value) return '--'
    if (!/^(\d*)(\.\d{1,})?$/.test(value)) return '--'
    if (rate == '') return '--'
    if (!/^\d*(\.\d{1,})?$/.test(rate)) return '--'
    if (parseFloat(rate) < 0 || parseFloat(rate) > 100) return '--'
    rate = accDiv(rate, 100) // parseFloat(rate) / 100
    let resResult = accMul(value, rate).toFixed(2)
    return resResult
}

export function getParseInt(arg){
    if(arg&&!isNaN(arg)){
       return parseInt(arg)
    }else{
       return 0
    }  
}
export function getNotZeroNum(num1,num2){
    let  result=0
    if(!isNaN(num1)&&num1>0){
        result=num1
    }else if(!isNaN(num2)&&num2>0){
        result=num2
    }else{
        result=0
    }
    return result
}

// 乘法 
export function accMul(arg1,arg2) { 
    var m=0,s1=arg1.toString(),s2=arg2.toString(); 
    try{m+=s1.split(".")[1].length}catch(e){} 
    try{m+=s2.split(".")[1].length}catch(e){} 
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m) 
} 

//除法
export function accDiv(arg1,arg2){ 
    var t1=0,t2=0,r1,r2; 
    try{t1=arg1.toString().split(".")[1].length}catch(e){} 
    try{t2=arg2.toString().split(".")[1].length}catch(e){} 
    r1=Number(arg1.toString().replace(".","")) 
    r2=Number(arg2.toString().replace(".","")) 
    return accMul((r1/r2),Math.pow(10,t2-t1)); 
}

//加法 
export function accAdd(arg1,arg2){ 
    var r1,r2,m; 
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0} 
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0} 
    m=Math.pow(10,Math.max(r1,r2)) 
    return (arg1*m+arg2*m)/m 
} 

//减法 
export function accSub(arg1,arg2){ 
    var r1,r2,m,n; 
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0} 
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0} 
    m=Math.pow(10,Math.max(r1,r2)); 
    n=(r1>=r2)?r1:r2; 
    return ((arg1*m-arg2*m)/m).toFixed(n); 
}
export function getTwoPointerNumber(str){
    if(!str||isNaN(str)){
        return ''
    }else{
        let twoPointer=Number(str).toFixed(2)
        let length=twoPointer.length
        if(twoPointer[length-1]=='0'&&twoPointer[length-2]=='0'){
            return parseInt(twoPointer)
        }else{
            return twoPointer
        }
    }
}
export function computeSub(arg1,arg2,arg3){ 
    if(!arg1||isNaN(parseFloat(arg1))){
        arg1=0
    }
    if(!arg2||isNaN(parseFloat(arg2))){
        arg2=0
    }
    if(!arg3||isNaN(parseFloat(arg3))){
        arg3=0
    }
    let result=(arg1-arg2-arg3).toFixed(2)
    return getTwoPointerNumber(result)
}


import md5 from 'md5'
export const signKey='wZ8ZpJ8erHiO0gDa23wqykRuCwfJkR2g'
export function getSignStr(arg) {
  var result = ''
  if (arg) {
    var keyArr = Object.keys(arg).sort()
    var keyValueStr = ''
    for (var i = 0; i < keyArr.length; i++) {
      var keyName = keyArr[i]
      keyValueStr += keyName
      keyValueStr += arg[keyName]
    }
    keyValueStr += signKey
    result = md5(keyValueStr)
  }
  return result
}


// 去除字符串首尾空格
export function cTrim(str) {
	if (typeof str === 'string') return str.replace(/^\s*|\s*$/g, '');
    return '';
}